import React, { Component } from 'react';

import { captureException } from '../../services/sentry';

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    captureException(error);
    return { error };
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div>
          <details open>
            <summary>Oops! Something went wrong.</summary>
            {error && error.toString()}
          </details>
        </div>
      );
    }

    const { children } = this.props;
    return children;
  }
}
